import { createFileRoute, redirect } from "@tanstack/react-router"
import { ApiError } from "@/lib/api"
import { lastWorkspace, meQuery } from "@/lib/queries"

/** Sends a signed-in member to their last workspace, a new account to workspace creation, and everyone else to sign-in. */
export const Route = createFileRoute("/")({
  beforeLoad: async ({ context }) => {
    let me
    try {
      me = await context.queryClient.ensureQueryData(meQuery)
    } catch (error) {
      if (error instanceof ApiError && error.status === 401) throw redirect({ to: "/sign-in" })
      throw error
    }
    if (me.memberships.length === 0) throw redirect({ to: "/create-workspace" })
    const remembered = lastWorkspace()
    const target = me.memberships.find((m) => m.workspace.slug === remembered) ?? me.memberships[0]!
    throw redirect({ to: "/w/$workspace/overview", params: { workspace: target.workspace.slug } })
  },
})
